<cap-content-header>
  <cap-title>
    {{ "publikation.ListTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <cap-functionbar-searchresult-buttons [listLoader]="listLoader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

<div class="my-4">
  @if (listLoader) {
    <div>
      <cap-list-loader [listLoader]="listLoader">
        <div class="cap-list-loader-title">
          <ng-content select="[name=title]"></ng-content>
        </div>
        <div class="cap-list-loader-content">
          <table class="cap-table-search">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
              <tr>
                <td class="p-0" colspan="100">
                  <!-- for bottom table border if last row collapsed -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    </div>
  } @else {
    <cap-spinner-small></cap-spinner-small>
  }
</div>

<ng-template #tableHeaders>
  <tr>
    <th style="width: 5%">
      <a (click)="expandOrCollapse()" class="btn">
        @if (allExpanded) {
          <span><i class="fas fa-angle-down"></i> </span>
        }
        @if (!allExpanded) {
          <span><i class="fas fa-angle-right"></i></span>
        }
      </a>
    </th>
    <th>
      <cap-column-header [columnName]="'Gemeinde'" [sortModel]="tableSortModel.columns.get('gemeinde')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Grundstück'" [sortModel]="tableSortModel.columns.get('grundstueck')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Publikationsdatum'" [sortModel]="tableSortModel.columns.get('publikationsdatum')">
      </cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('geschaeftsNummer')"></cap-column-header>
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr (mouseleave)="item.hovered = false" (mouseover)="item.hovered = true" [class.background-color-like-hover]="item.hovered">
      <td>
        <a (click)="item.expanded = !item.expanded" class="btn">
          @if (item.expanded) {
            <span><i class="fas fa-angle-down"></i> </span>
          }
          @if (!item.expanded) {
            <span><i class="fas fa-angle-right"></i></span>
          }
        </a>
      </td>
      <td>
        {{ item.publikationListEntry.grundstueck.grundstueckNummer.gbGemeinde?.name | translateName }}
        {{ item.publikationListEntry.grundstueck.grundstueckNummer.gbGemeinde.bfsNummer }}
      </td>
      <td>
        <cap-kompakt-grundstueck [item]="item.publikationListEntry.grundstueck"></cap-kompakt-grundstueck>
      </td>
      <td>
        {{ item.publikationListEntry.publikationsdatum | datum }}
      </td>
      <td>
        <cap-kompakt-grundbuchgeschaeft [item]="item.publikationListEntry.grundbuchgeschaeft"></cap-kompakt-grundbuchgeschaeft>
      </td>
    </tr>
    <tr>
      <!-- dummy row for stripped rows with modulo 3 -->
    </tr>
    <tr (mouseleave)="item.hovered = false" (mouseover)="item.hovered = true" [class.background-color-like-hover]="item.hovered">
      @if (item.expanded) {
        <td colspan="100">
          <cap-publikation-list-detail [publikation]="item.publikationListEntry"></cap-publikation-list-detail>
        </td>
      }
    </tr>
  }
</ng-template>
